export const completedCodeKey = "completedCode";
